// Centralized style configuration for consistency and easy customization
export const STYLES = {
  spacing: {
    page: "p-8",
    card: "p-8",
    section: "gap-6",
    subsection: "gap-4",
    element: "gap-3",
    small: "gap-1",
  },
  table: {
    cellPadding: "p-1",
    footerPadding: "p-4",
  },
  container: {
    maxWidth: "max-w-[1600px]",
    minWidth: "min-w-[1400px]",
  },
  border: {
    width: "border-2",
    radius: "rounded-[var(--radius)]",
  },
} as const;
